// ------------------------------------------
// アイデア集のモーダル（開いた1件のみ表示）
// ------------------------------------------
class IdeaModal {
  constructor(el, opt) {
    this.modal = document.querySelector('.' + el);
    if (this.modal) {
      this.slides = this.modal.querySelectorAll('.js-idea-slide');
      this.box = this.modal.querySelector('.js-idea-box');
      this.closeBtn = this.modal.querySelector('.p-idea__modal-close');
      this.index = 0;
      this.trap = new FocusTrap(this.modal.querySelector('[role="dialog"]') || this.modal);
      this.event();
    }
  }

  event() {
    document.querySelectorAll('.js-idea-open').forEach((btn) => {
      btn.addEventListener('click', () => this.open(Number(btn.dataset.index) || 0));
    });

    this.modal.querySelectorAll('.js-idea-close').forEach((btn) => {
      btn.addEventListener('click', () => this.close());
    });

    document.addEventListener('keydown', (e) => {
      if (!this.modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') this.close();
    });
  }

  open(index) {
    this.show(index);
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    lockBodyScroll();
    this.trap.activate(this.closeBtn);
  }

  close() {
    if (!this.modal.classList.contains('is-open')) return;
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    unlockBodyScroll();
    this.trap.deactivate();
  }

  show(index) {
    const total = this.slides.length;
    if (!total) return;
    this.index = ((index % total) + total) % total;
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.index);
    });
    this.box.scrollTop = 0;
  }
}
